import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        permissions: []
    },
    getters: {
        permissions(state) {
            return state.permissions;
        }
    },
    actions: {
        async fetch(context) {
            return httpClient
                .get("/api/guest/permissions")
                .then(data => context.commit("SET_PERMISSIONS", data));
        }
    },
    mutations: {
        SET_PERMISSIONS(state, data) {
            state.permissions = data;
        }
    }
};
